<template>
  <div class="animated fadeIn">
    <b-card>
      <b-table :items="items" :fields="fields">
        <template slot="idCategory" slot-scope="row">
          <inputSelect :field="{label: '', name: 'idCategory-item', values: this.categoriesValues}" :data="row.value"/>
        </template>
        <template slot="idSubCategory" slot-scope="row">
            <inputSelect :field="{label:'', name: 'idSubCategory-item', values: this.subcategoriesValues}" :data="row.value"/>
        </template>
        <template slot="idProduct" slot-scope="row">
            <inputSelect :field="{label:'', name: 'idProduct-item', values: this.productsValues}" :data="row.value"/>
        </template>
        <template slot="price" slot-scope="row">
            <inputText :field="{label:'',name: 'price-item'}" :data="row.value"/>
        </template>
        <template slot="count" slot-scope="row">
            <inputText :field="{label:'',name: 'count-item'}" :data="row.value"/>
        </template>
        <template slot="total" slot-scope="row">
            <inputText :field="{label:'',name: 'total-item'}" :data="row.value"/>
        </template>
      </b-table>
    </b-card>
  </div>
</template>
<script>
import inputSelect from '@/views/base/form/inputSelect'
import inputText from '@/views/base/form/inputText'
const items = [
  { idCategory: 12, idSubCategory: 40, idProduct: 'Dickerson', price: 1000, count: 2, total: 2000 },
  { idCategory: 12, idSubCategory: 40, idProduct: 'Dickerson', price: 1000, count: 2, total: 2000 }
]
export default {
  name: 'items',
  components: {
    inputSelect,
    inputText
  },
  data () {
    return {
      items: items,
      fields: [
        {key: 'idCategory-item', label: 'Categoria'},
        {key: 'idSubCategory-item', label: 'Subcategoria'},
        { key: 'idProduct-item', label: 'Producto' },
        { key: 'price-item', label: 'Precio' },
        { key: 'count-item', label: 'Cantidad' },
        { key: 'total-item', label: 'Total' }
      ],
      categoriesValues: [],
      subcategoriesValues: [],
      productsValues: []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/papeleria/requests/items.vue